import { render, staticRenderFns } from "./AttendanceReminder.vue?vue&type=template&id=b504658e&scoped=true"
import script from "./AttendanceReminder.vue?vue&type=script&lang=js"
export * from "./AttendanceReminder.vue?vue&type=script&lang=js"
import style0 from "./AttendanceReminder.vue?vue&type=style&index=0&id=b504658e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b504658e",
  null
  
)

export default component.exports